<template>
  <div class="game-list-page">

    <div class="header">
      <div class="hd-bg">
        <div class="tip">{{ headerTip }}</div>
      </div>
      <div class="title"><h2>{{ headerTitle }}</h2></div>
    </div>

    <div class="cards a-fadeinB">

      <game-card
        v-if="last.isShow"
        :game="last"
        :is-last-game="true"
        :button-text="buttonText"
        @game-click="toGame(last['url'])"
      />

      <game-card
        v-for="(value, index) in dataList"
        v-if="shouldShowGame(value)"
        :key="index"
        :game="value"
        :is-favorite="favorIdList.includes(value.id)"
        :button-text="buttonText"
        @game-click="toGame(value['url'], value)"
        @favorite-toggle="handleFavorite(index, value)"
      />

      <div>
        <div v-if="moreShowBoolen" @click="moreShow" class="more">点击查看更多</div>
        <div v-else class="no-more">已无更多</div>
      </div>

    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import GameCard from './GameCard'

  export default {
    name: "GameListPage",
    components: {
      GameCard
    },
    props: {
      pageType: {
        type: String,
        required: true,
        validator: (value) => ['phone', 'pc', 'other'].includes(value)
      },
      headerTip: {
        type: String,
        required: true
      },
      headerTitle: {
        type: String,
        required: true
      },
      buttonText: {
        type: String,
        default: '开始游戏'
      },
      gameData: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        cardData: [],
        dataList: [],                         // dom上显示的数组，懒加载，10个一组
        favorIdList: [],                      // 我喜欢列表
        totalData: [],                        // 排列好顺序之后的游戏数组
        moreShowBoolen: false,                // 更多内容按钮
        nowPage: 1,                           // 配合懒加载，第一页
        isLoading: false,                     // 防止重复加载
        scrollHandler: null,                  // 存储滚动处理器引用以便清理
        SCROLL_LOAD_THRESHOLD: 50,            // 触发加载的距离底部阈值（像素）
        LOADING_RESET_DELAY: 500,             // 加载标志重置延迟（毫秒）
        cardZIndex: 10,

        last: {
          name: '赛车游戏带闯关',
          id: '046',
          type: 'pc',
          desc: '赛车游戏带闯关',
          more: '打怪小游戏，一款冒险闯关的小游戏',
          url: 'https://game.chenmo1212.cn/content/046/index.html',
          cover: 'https://game.chenmo1212.cn/content/046/cover.png',
          isShow: false,
        }
      }
    },
    computed: {
      localStorageKey() {
        return `${this.pageType}_lastGame`;
      },
      favoriteStorageKey() {
        return this.pageType === 'phone' ? 'favorIdList' : 'otherFavorIdList';
      }
    },
    created() {
      // Use game data from props (filtered by parent component)
      this.cardData = this.gameData;

      // Load last game from localStorage
      if (typeof localStorage[this.localStorageKey] !== 'undefined') {
        const lastGame = JSON.parse(localStorage[this.localStorageKey]);
        if (lastGame.isShow) {
          this.last = lastGame;
        }
      }
    },
    mounted() {
      this.flashCard();

      const that = this;

      // header and infinite scroll with throttling
      let lastScrollTime = 0;
      const throttleDelay = 200;

      this.scrollHandler = function () {
        const now = Date.now();
        if (now - lastScrollTime < throttleDelay) {
          return;
        }
        lastScrollTime = now;

        const title = $(".title");

        if ($(window).scrollTop() >= 15) {
          title.addClass("bg");
        } else {
          title.removeClass("bg");
        }

        // Infinite scroll - load more when at bottom
        if (that.moreShowBoolen && !that.isLoading) {
          const scrollTop = $(window).scrollTop();
          const windowHeight = $(window).height();
          const documentHeight = $(document).height();
          
          // Trigger load more when reaching bottom
          if (scrollTop + windowHeight >= documentHeight - that.SCROLL_LOAD_THRESHOLD) {
            that.isLoading = true;
            that.moreShow();
          }
        }
      };

      $(window).scroll(this.scrollHandler);

      // 获取本地的我喜欢列表
      if (typeof localStorage[this.favoriteStorageKey] !== 'undefined') {
        // 本地存在，且长度不唯一才可以
        const storedFavorites = JSON.parse(localStorage[this.favoriteStorageKey]);
        if (storedFavorites.length >= 0) {
          this.favorIdList = storedFavorites;
          this.totalData = this.changeOrder(this.cardData, this.favorIdList);

          // cardData
          this.init(this.totalData);
        }
      } else {
        this.init(this.cardData);
      }
    },
    beforeDestroy() {
      // 清理滚动事件监听器以防止内存泄漏
      if (this.scrollHandler) {
        $(window).off('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
      
      // 清理卡片点击事件
      $("div.cards").off("click.cardToggle", "div.card");
      
      // 重置数据状态
      this.dataList = [];
      this.totalData = [];
      this.nowPage = 1;
      this.isLoading = false;
    },
    methods: {
      shouldShowGame(game) {
        // Data is already filtered by parent component, just show all
        return true;
      },

      toGame(url, item) {
        let tempWindow = window.open('_blank');
        tempWindow.location = url;

        if (item) {
          this.last = item;
          this.last["isShow"] = true;

          // 把最后一次的游戏存入本地
          localStorage.setItem(this.localStorageKey, JSON.stringify(this.last));
        }
      },

      /**
       * 初始化列表，为懒加载做准备
       * @param totalData 总数据
       */
      init(totalData) {
        if (totalData.length <= 10) { // 10条数据一页
          this.dataList = totalData;
          this.moreShowBoolen = false;
        } else {
          this.dataList = totalData.slice(0, 10);
          this.moreShowBoolen = true;
        }
      },

      /**
       * 更改游戏顺序
       * @param total 总数据
       * @param favor 我喜欢
       */
      changeOrder(total, favor) {
        // 喜欢的列表
        let like = total.filter((item) => {
          return favor.includes(item.id);
        });

        // 不喜欢的
        let noLike = total.filter((item) => {
          return !favor.includes(item.id);
        });

        // 合并两个
        return like.concat(noLike);
      },

      moreShow() { // 点击查询更多
        const sourceData = this.totalData.length > 0 ? this.totalData : this.cardData;
        this.dataList = this.dataList.concat(sourceData.slice(this.nowPage * 10, (this.nowPage + 1) * 10));
        this.nowPage++;
        this.moreShowBoolen = sourceData.length >= this.nowPage * 10;
        this.flashCard();
        
        // 重置加载标志，确保在数据加载完成后
        setTimeout(() => {
          this.isLoading = false;
        }, this.LOADING_RESET_DELAY);
      },

      handleFavorite(index, value) {
        if (!this.favorIdList.includes(value.id)) {
          this.favorIdList.push(value.id);
        } else {
          this.favorIdList.splice(this.favorIdList.findIndex(item => item === value.id), 1);
        }

        localStorage.setItem(this.favoriteStorageKey, JSON.stringify(this.favorIdList));
      },

      favoriteStyle(id) {
        if (this.favorIdList.includes(id)) {
          // 存在则激活
          return 'active heart';
        } else {
          return 'heart';
        }
      },

      flashCard() {
        const component = this;

        $("div.cards")
          .off("click.cardToggle", "div.card")
          .on("click.cardToggle", "div.card", function (e) {
            if ($(e.target).closest(".card-actions, #heart").length) {
              return;
            }

            e.preventDefault();

            const cards = $("div.cards");
            const currentCard = $(this);
            const isShowing = currentCard.hasClass("show");

            if (cards.hasClass("showing")) {
              $("div.card.show").removeClass("show");

              if (isShowing) {
                cards.removeClass("showing");
              } else {
                currentCard
                  .css({ zIndex: component.cardZIndex })
                  .addClass("show");
                component.cardZIndex += 1;
              }
            } else {
              cards.addClass("showing");
              currentCard
                .css({ zIndex: component.cardZIndex })
                .addClass("show");
              component.cardZIndex += 1;
            }
          });
      }
    }
  }
</script>

<style scoped>
  @import '../css/cards.css';
  .game-list-page {
    background-color: #f5f6f6;
    min-height: 100vh;
  }

  .header {
    height: 240px;
    width: 100%;
  }

  .hd-bg {
    height: 100%;
    width: 100%;
    background: linear-gradient(100deg, #24A4EA, #379DEB 25%, #B76BF0);
    background-image: url(../assets/bg.png);
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
  }

  .hd-bg .tip {
    line-height: 180px;
    color: #fff;
  }

  .bg {
    height: 70px !important;
    background: linear-gradient(100deg, #24A4EA, #379DEB 25%, #B76BF0);
  }

  .title {
    height: 60px;
    color: #fff;
    position: fixed;
    width: 100%;
    z-index: 1000;
    top: 0;
    background: linear-gradient(100deg, #24A4EA, #379DEB 25%, #B76BF0);
  }
  
  .title h2 {
    margin: 0;
    padding: 0;
    line-height: 60px;
  }

  .more,
  .no-more {
    margin-top: 20px;
    background: linear-gradient(100deg, #24A4EA, #379DEB 25%, #B76BF0);
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.25);
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.25);
    color: #ffffff;
    display: inline-block;
    padding: 6px 30px 8px;
    position: relative;
    text-decoration: none;
    -webkit-transition: all 0.1s 0s ease-out;
    transition: all 0.1s 0s ease-out;
    cursor: pointer;
  }

  /* Mobile responsive fixes for header */
  @media screen and (max-width: 768px) {
    .header {
      height: 200px;
    }
    
    .hd-bg .tip {
      line-height: 140px;
      font-size: 14px;
      padding: 0 20px;
    }
    
    .title h2 {
      font-size: 18px;
    }
  }
  
  @media screen and (max-width: 480px) {
    .header {
      height: 180px;
    }
    
    .hd-bg .tip {
      line-height: 120px;
      font-size: 13px;
    }
    
    .title h2 {
      font-size: 16px;
    }
  }

</style>